import React from "react";

const Loader = () => {
  return (
    <div className="flex flex-col justify-center items-center mt-20">
      <div className="flex space-x-2 mb-6">
        <style>
          {`
            @keyframes threeDotsBounce {
              0%, 80%, 100% {
                transform: scale(0);
              }
              40% {
                transform: scale(1.0);
              }
            }
            .dot-bounce {
              width: 0.5rem; /* 16px */
              height: 0.5rem; /* 16px */
              background-color: #4F8382; /* Ganti dengan warna yang Anda inginkan, contoh: biru */
              border-radius: 100%;
              display: inline-block;
              animation: threeDotsBounce 1.4s infinite ease-in-out both;
            }
          `}
        </style>
        <div className="dot-bounce" style={{ animationDelay: '-0.32s' }}></div>
        <div className="dot-bounce" style={{ animationDelay: '-0.16s' }}></div>
        <div className="dot-bounce"></div>
      </div>
      <p className="text-sm text-gray-700">Silakan Tunggu ...</p>
    </div>
  );
};

export default Loader;
